//@flow

export type SignUpSIMCardScanActionType =
  | {|
      type: 'SIGNUP_SET_SIM_CARD_NUMBER',
      payload: {|
        SIMSerialNumber: string,
      |},
    |}
  | {|
      type: 'SIGNUP_CONFIRM_SIM_CARD_NUMBER',
      payload: {|
        number: string,
      |},
    |};

export const confirmSIMCardNumber = (formValues: {| number: string |}): SignUpSIMCardScanActionType => ({
  type: 'SIGNUP_CONFIRM_SIM_CARD_NUMBER',
  payload: formValues,
});

export const setSIMCardNumber = (SIMSerialNumber: string): SignUpSIMCardScanActionType => ({
  type: 'SIGNUP_SET_SIM_CARD_NUMBER',
  payload: {
    SIMSerialNumber,
  },
});
